import { useCallback, useEffect, useRef } from 'react';

//
// useAsync is used in any component that performs inline asynchronous operations.
// This hook will watch for the component being unmounted. After doing any await,
// the calling component should check the return value of isMounted() before it
// attempts to update component state.
//
// e.g.
// const fullyAsync = useCallback(async () => {
//     const result = await someAsyncFunction();
//     if (!isMounted()) return;  <-- check isMounted()
//     setData(result);
// }, [ setData, isMounted ]);
//
// const partiallyAsync = useCallback(() => {
//     setBusy(false);
//     setErrorKey('');
//     void (async () => {
//         try {
//             const result = await someAsyncFunction();
//             if (!isMounted()) return;  <-- check isMounted()
//             setData(result);
//         }
//         catch (e) {
//             if (!isMounted()) return;  <-- check isMounted()
//             setErrorKey(e.message);
//         }
//         finally {
//             isMounted() && setBusy(false);  <-- check isMounted()
//         }
//     })();
// }, [ setData, setBusy, setErrorKey, isMounted ]);
//
export function useAsync() {
    const mountedRef = useRef(true);

    const isMounted = useCallback(() => {
        return mountedRef.current;
    }, [ mountedRef ]);

    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, [ mountedRef ]);

    return {
        isMounted,
    };
}
